var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"daiban-container"},[_c('van-nav-bar',{staticClass:"home-nav-bar",attrs:{"title":" 该模块火速开发中。。。"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }